import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import "../../Styles/UserDashboard/Gestion.css";
import { Button, FormControl, Spinner } from "react-bootstrap";
import API from '../Authentification/api';

const ModifierPassword = ({ closePopUp3, length = 4 }) => {
    const inputsRef = useRef([]);
    const navigate = useNavigate();
    const [userEmail, setUserEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [timer, setTimer] = useState(0);
    const [isRequestDisabled, setIsRequestDisabled] = useState(false);

    // Compte à rebours
    useEffect(() => {
        let interval;
        if (timer > 0) {
            interval = setInterval(() => setTimer(prev => prev - 1), 1000);
        } else {
            setIsRequestDisabled(false);
        }
        return () => clearInterval(interval);
    }, [timer]);

    // Récupération email de l’utilisateur connecté
    const fetchUserProfile = async () => {
        const token = localStorage.getItem("token");
        if (!token) return (window.location.href = "/login");
        try {
            const response = await API.get("/user", {
                headers: { Authorization: `Bearer ${token}` },
            });
            setUserEmail(response.data.email);
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error("Erreur profil:", error);
            }

        }
    };
    useEffect(() => { fetchUserProfile(); }, []);

    // Focus automatique sur la première case à l'ouverture (utile sur mobile)
    useEffect(() => {
        inputsRef.current[0]?.focus();
    }, []);

    const handleChange = (e, index) => {
        const value = e.target.value;

        // On efface tout caractère qui n'est pas un chiffre unique
        // (le champ n'étant pas contrôlé par React, il faut le faire manuellement)
        if (!/^[0-9]$/.test(value)) {
            e.target.value = "";
            return;
        }

        if (index < length - 1) inputsRef.current[index + 1].focus();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !e.target.value && index > 0)
            inputsRef.current[index - 1].focus();
        if (e.key === "ArrowLeft" && index > 0)
            inputsRef.current[index - 1].focus();
        if (e.key === "ArrowRight" && index < length - 1)
            inputsRef.current[index + 1].focus();
    };

    // Gère le collage d'un code complet (autofill SMS sur mobile)
    const handlePaste = (e) => {
        e.preventDefault();
        const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, length);
        if (!pasted) return;

        pasted.split("").forEach((char, i) => {
            if (inputsRef.current[i]) inputsRef.current[i].value = char;
        });

        const nextIndex = pasted.length < length ? pasted.length : length - 1;
        inputsRef.current[nextIndex]?.focus();
    };

    const getOtpCode = () => inputsRef.current.map(input => input.value).join('');

    const verifyOtp = async () => {

        const otpCode = getOtpCode();
        if (otpCode.length !== length) {
            toast.error("Veuillez remplir tous les champs du code.");
            return;
        }
        setLoading(true);

        try {
            const res = await API.post("/user/verify-otp", {
                email: userEmail,
                otp: otpCode,
            });

            toast.success(res.data.message);
            closePopUp3();
            // Stocker le code OTP validé temporairement
            localStorage.setItem("reset_otp", res.data.reset_token);
            navigate("/reset-password");
        } catch (error) {
            if (process.env.NODE_ENV !== 'production') {
                console.error(error);
            }
            toast.error(error.response?.data?.message || "Code OTP invalide !");
        } finally {
            setLoading(false);
        }
    };

    const sendNewOtp = async () => {
        try {
            await API.post("/user/request-otp", { email: userEmail });
            toast.success("Nouveau code OTP envoyé !");
            inputsRef.current.forEach(input => (input.value = ""));
            inputsRef.current[0].focus();
        } catch (error) {
            toast.error("Impossible d'envoyer le code OTP.");
        }
    };

    const handleRequestNewOtp = async () => {
        setIsRequestDisabled(true);
        setTimer(60); // 1 minute
        await sendNewOtp();
    };

    return (
        <div className='popup-overlay'>
            <div className="popup rounded-3 shadow-sm p-3">
                <button onClick={closePopUp3} className="bouton-close" style={{ color: "red" }}>✕</button>
                <h3 className="text-center taux_moyen">Code de sécurité</h3>
                <p className="text-center texte_brut">
                    Entrez le code de sécurité envoyé à votre email
                </p>
                <div className='d-flex flex-column align-items-center justify-content-center form-otp'>
                    <div className="content-otp">
                        {Array.from({ length }).map((_, i) => (
                            <FormControl
                                key={i}
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                autoComplete={i === 0 ? "one-time-code" : "off"}
                                maxLength={1}
                                placeholder=" "
                                className="text-center fs-3 input-otp"
                                ref={(el) => (inputsRef.current[i] = el)}
                                onChange={(e) => handleChange(e, i)}
                                onKeyDown={(e) => handleKeyDown(e, i)}
                                onPaste={handlePaste}
                            />
                        ))}
                    </div>
                    <Button type='submit' className='w-100 rounded-5 mt-3' onClick={verifyOtp}>
                        {loading ? <Spinner size="sm" animation='border' /> : "Réinitialiser le mot de passe"}
                    </Button>
                    <Button
                        className="border-0 bg-white petit_titre mt-2 text-primary"
                        disabled={isRequestDisabled}
                        onClick={handleRequestNewOtp}
                    >
                        {isRequestDisabled ? `Attendez ${timer}s` : "Demandez un nouveau code"}
                    </Button>
                    <svg className="svg" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#4073ff" d="M56.8,-23.9C61.7,-3.2,45.7,18.8,26.5,31.7C7.2,44.6,-15.2,48.2,-35.5,36.5C-55.8,24.7,-73.9,-2.6,-67.6,-25.2C-61.3,-47.7,-30.6,-65.6,-2.4,-64.8C25.9,-64.1,51.8,-44.7,56.8,-23.9Z" transform="translate(100 100)" className="path"></path>
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default ModifierPassword;
